import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DropdownFilterService } from 'src/app/services/index-service';
import { arrayToPipeString } from 'src/app/shared/helper/custom-function';

@Component({
	selector: 'app-rsm-filter',
	template: `
		<app-select-filter 
			[hasIcon] = "hasIcon"
			bindLabel = "name"
			bindValue = "id"
			placeholder = "Select RSM"
			label = "RSM"
			[clearable]="multiple"
			[multiple] = "multiple"
			[items] = "metadata.data"
			[(value)] = value
			(valueChange)="valueChange.emit(value)"
		>
		</app-select-filter>
    `,
})

export class AppRSMFilterComponent implements OnInit {
	@Input() params: Object = {};
	@Input() multiple = false;
	@Input() value: any = null;
	@Output() valueChange = new EventEmitter();
	@Input() sdIds = null;
	@Input() hasIcon = false;
	metadata = {
		data: [],
		limit: 100,
		total: 0,
		search: '',
	}
	constructor(private dropdownFilter: DropdownFilterService) { }

	ngOnInit() {
		this.getRSMs();
	}

	getRSMs() {
		let mtd = this.metadata;
		if (!mtd.data.length || mtd.data.length < mtd.total) {
			const params = {
				status: 'active',
				limit: mtd.limit,
				offset: mtd.data.length,
				sdIds: arrayToPipeString(this.sdIds),
				...this.params
			};
			this.dropdownFilter
				.getRSMList(params)
				.subscribe((res: any) => {
					const mappedData = (res.data || []).map(d => {
						return {
							id: d.id,
							name: d.fullName,
						}
					})
					mtd.data = [...mtd.data, ...mappedData];
					mtd.total = res.metadata.total;

					if (mtd.data.length && mtd.data.length < mtd.total) this.getRSMs();
					else {
						if (!this.multiple) {
							mtd.data.unshift({
								id: '',
								name: 'All',
							});
							this.value = this.value || mtd.data[0].id;
						}
					}
				});
		}

	}

	filter() {
		this.value = null;
		this.metadata.data = [];
		this.getRSMs();
	}

	refresh() {
		this.metadata.data = [];
		this.getRSMs();
	}
}